module.exports = __webpack_public_path__ + "static/media/49 - Leo Sayer - Easy To Love.0b8ef45e.mp3";